// extracted by mini-css-extract-plugin
export default {"transactions":"styles_transactions__RiTYW","fieldWrapper":"styles_fieldWrapper__cpNXG","search":"styles_search__2jJ3z","value":"styles_value__lQuuP"};